// extracted by mini-css-extract-plugin
module.exports = {"root":"Home3EmptyState_root__kaAg5","illustration":"Home3EmptyState_illustration__Fs6yw","copy":"Home3EmptyState_copy__xYOog","title":"Home3EmptyState_title__Vy65g"};